export default class AuthPolicy {
    static readonly Admin: string[] = ["wcz-developers"];
    static readonly Contributor: string[] = ["wcz-developers", "WCZ_App.App_store-contributor"];
}